import styled from "styled-components";
import PUBfooterSafari from "../../../pub/src/data/img/pub-footer-img.png";
import PUBfooter from "../../../pub/src/data/img/pub-footer-img.webp";
import { ReactComponent as Logo18img } from "common/src/assets/img/logo_18.svg";
import { isDesktop, isMobile, isTablet } from "react-device-detect";

export const FooterWrapper = styled.div`
  width: ${isMobile ? "var(--footerWrapperWidthMobile)" : "100vw"};
  max-width: var(--footerWrapperMaxWidth);
  margin: var(--footerWrapperMargin);
  border-radius: var(--footerWrapperBorderRadius);
  background-image: "";
  background-position: top;
  background-repeat: no-repeat;
  padding-top: ${({ game }) => (game ? "0" : "5rem")};
  background-color: ${({ game }) =>
    game ? "var(--footerWrapperBgGame)" : "var(--footerWrapperBgNoGame)"};

  @media screen and (max-width: 767px) {
    padding-top: ${({ game }) =>
      game ? "0" : "var(--footerWrapperPaddingTopMobile)"};
    padding-bottom: 30px;
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    padding-top: ${({ game }) =>
      game ? "0" : "var(--footerWrapperPaddingTopTablet)"};
  }
`;

export const FooterLinksWrapper = styled.section`
  width: 100%;
  background-color: var(--footerLinksSectionBg);
  text-align: center;
  font-family: var(--footerLinksSectionFontFamily);
  border-radius: var(--footerLinksSectionBorderRadius);

  @media screen and (max-width: 767px) {
    width: 100%;
    height: 100%;
    padding: 0;
  }
`;

export const StyledFooterLinks = styled.div`
  display: flex;
  justify-content: ${({ abc }) =>
    abc ? "var(--footerLinksJustifyWhenAbc)" : "center"};
  flex-direction: row;
  background-color: ${({ abc, background }) => {
    if (background) return "var(--footerBubleBG)";
    if (!abc) return "var(--footerLinksBgWhenNotAbc)";
    return "";
  }};
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  width: ${({ abcextra }) =>
    abcextra ? "var(--footerLinksWidthAbcextra)" : "var(--footerLinksWidth)"};
  max-width: ${({ abcextra }) =>
    abcextra
      ? "var(--footerLinksMaxWidthAbcextra)"
      : "var(--footerLinksMaxWidth)"};
  font-size: 12px;
  font-weight: 600;
  margin: 0 auto;
  padding: ${({ pubsize }) =>
    pubsize && !isMobile
      ? "var(--footerLinksPaddingPubsize)"
      : "var(--footerLinksPadding)"};
  background-color: ${({ background }) => background && "var(--footerBubleBG)"};
  border-radius: ${({ background }) => background && "45px"};
  text-transform: ${({ capitalize }) =>
    capitalize ? "capitalize" : "uppercase"};
  border-bottom: ${({ noborder, pubcolor }) =>
    noborder
      ? ""
      : pubcolor
        ? "var(--footerLinksBorderBottomPubcolor)"
        : "var(--footerLinksBorderBottom)"};

  a {
    flex-wrap: wrap;
    color: #fff;
    padding: ${({ abc }) =>
      abc ? "var(--footerLinksAnchorPaddingWhenAbc)" : "20px"};
    text-transform: capitalize;
  }
  div {
    z-index: var(--footerLinksDivZIndex);
    flex-wrap: wrap;
    padding: 8px;
    font-size: ${({ abc }) =>
      abc ? "var(--footerLinksDivFontSizeWhenAbc)" : "12px"};
    font-weight: var(--footerLinksDivFontWeight);
    a {
      text-transform: ${({ abc }) =>
        abc ? "var(--footerLinksAnchorTextTransformWhenAbc)" : ""};
      color: ${({ abc }) =>
        abc
          ? "var(--footerLinksAnchorColorWhenAbc)"
          : "var(--footerLinksAnchorColor)"};
    }
  }
  svg {
    cursor: pointer;
    width: 42px;
    height: 32px;
    padding-right: 6px;
  }

  @media (max-width: 568px) {
    a {
      padding: 10px;
    }
  }

  @media (max-width: 767px) {
    width: 100%;
    justify-content: center;
    div {
      padding: 10px;
      a {
        padding: 10px 0;
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    width: var(--footerLinksWidthTablet);
    justify-content: center;
  }
`;

export const StyledFooterText = styled.section`
  text-align: justify;
  display: var(--footerTextDisplay, block);
  flex-wrap: var(--footerTextFlexWrap, nowrap);
  font-size: var(--footerTextFontSize, inherit);
  color: var(--footerTextBodyColor, var(--footerTextColor));
  width: ${({ expand }) => (expand ? "100%" : "var(--footerTextWidth)")};
  max-width: ${({ expand }) => (expand ? "100%" : "var(--footerTextMaxWidth)")};
  margin: ${isMobile
    ? "var(--footerTextMarginMobile)"
    : "var(--footerTextMarginDesktop)"};
  padding: var(--footerTextPadding);
  height: ${({ expand, companyInfo }) =>
    companyInfo ? "" : expand ? "100%" : "var(--footerTextHeight)"};
  padding-bottom: ${({ expand }) => (expand ? "20px" : "")};
  overflow-y: auto;
  scrollbar-color: var(--footerTextScrollbarColor, #afafaf #000000);
  font-weight: var(--footerTextFontWeight);
  line-height: var(--footerTextLineHeight);
  border-bottom: ${isMobile
    ? "var(--footerTextBorderBottomMobile)"
    : "var(--footerTextBorderBottomDesktop)"};

  .col-xl {
    padding-bottom: 40px;
  }
  a {
    text-decoration: underline;
    color: var(--footerTextLinkColor, var(--footerTextColor));
  }
  p {
    font-size: inherit;
    text-align: justify;
    color: var(--footerTextColor);
  }
  h3 {
    font-size: 26px;
    font-weight: 700;
    line-height: 30px;
    text-align: center;
    color: var(--footerTextH3Color, var(--footerh));
  }
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: var(--scrollbarBG);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--footerTextScrollbarThumb, var(--footerTextColor));
    border-radius: 5px;
    border: 0px solid var(--scrollbarBG);
  }

  @media (max-width: 767px) {
    width: 100%;
    overflow-y: hidden;
    height: ${({ expand, companyInfo }) =>
      companyInfo ? "" : expand ? "100%" : "200px"};
    padding: ${({ companyInfo }) =>
      companyInfo ? "0" : "var(--footerTextPaddingMobile, 0)"};
  }

  @media (min-width: 767px) and (max-width: 924px) {
    width: 90%;
  }
`;

export const FooterButton = styled.button`
  display: none;
  padding: var(--footerButtonPadding, 0);

  .material-icons {
    vertical-align: bottom;
  }

  @media screen and (max-width: 767px) {
    display: block;
    border: none;
    background-color: inherit;
    color: var(--footerButtonColorMobile);
    margin: 0 auto;
    padding: var(--footerButtonPaddingMobile, var(--footerButtonPadding, 0));
  }
`;

export const FooterBottomSection = styled.section`
  margin-top: 0;
  background-color: var(--footerColor);

  @media (min-width: 768px) and (max-width: 1024px) {
    width: var(--footerBottomSectionWidthTablet);
    margin: 0 auto;
  }
`;

export const CacSectionWrapper = styled.div`
  border-radius: 30px;
  background-color: var(--footerColor);
  min-height: ${({ inGame }) => (inGame ? "250px" : "500px")};
`;

export const StyledFooterBootom = styled.div`
  margin-top: var(--footerBottomMarginTop);
  width: 100%;
  height: var(--footerBottomHeight);
  background-color: var(--footerBottomBg);

  @media (max-width: 768px) {
    height: var(--footerBottomHeightMobile);
  }
`;

export const StyledTrustlyline = styled.div`
  width: var(--footerTrustlyWidth);
  max-width: var(--footerTrustlyMaxWidth);
  padding-top: var(--footerTrustlyPaddingTop);

  img {
    margin: 0;
  }
  p {
    color: #fff;
  }

  @media (max-width: 798px) {
    flex-direction: column;
    width: 350px;
    padding: var(--footerTrustlyPaddingMobile, 0 10px);
  }

  @media screen and (max-width: 767px) {
    img {
    }
    p {
      font-size: 0.8rem;
    }
  }
  @media (min-width: 767px) and (max-width: 924px) {
    width: 95%;
    margin: 0 40px;
    img {
    }
    p {
      font-size: 0.8rem;
    }
  }
`;

export const Logo18 = styled.div.attrs({
  className: `inline`,
})`
  display: inline-block;

  div {
    display: inline-block;
    color: var(--logo18TextColor);
    margin: ${({ qbcIndex }) =>
      qbcIndex ? "20px 20px 20px 0" : isTablet ? "0 10px" : "20px"};
    line-height: 1.2;
    font-size: 0.8rem;
    font-weight: 400;
    vertical-align: middle;
  }
  img {
    width: 40px !important;
    margin: 0 auto !important;
  }

  @media screen and (max-width: 767px) {
    position: ${({ maindescription }) =>
      maindescription && !isTablet && "absolute"};
    width: ${({ maindescription }) =>
      maindescription ? "var(--logo18MainDescWidth)" : ""};
    ${({ maindescription }) =>
      maindescription &&
      `
        top: ${
          isMobile
            ? "var(--logo18MainDescTopMobile)"
            : "var(--logo18MainDescTopDefault)"
        };
        left: ${
          isMobile
            ? "var(--logo18MainDescLeftMobile)"
            : "var(--logo18MainDescLeftDefault)"
        };
        right: ${
          isMobile
            ? "var(--logo18MainDescRightMobile)"
            : "var(--logo18MainDescRightDefault)"
        };
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        flex-flow: wrap-reverse;
      `}
    div {
      font-size: 10px;
    }

    padding: 0px;
    img {
      width: 14px;
    }
  }
`;

export const FotterLicences = styled.div`
  background-color: ${({ background }) => background && "var(--footerBubleBG)"};
  border-radius: ${({ background }) => background && "45px"};
  border-bottom: ${isMobile
    ? "var(--footerLicencesBorderBottomMobile)"
    : "var(--footerLicencesBorderBottomDesktop)"};
  display: flex;
  border-left: ${isMobile ? "var(--footerLicencesBorderSideMobile)" : ""};
  border-right: ${isMobile ? "var(--footerLicencesBorderSideMobile)" : ""};
  flex-direction: row;
  flex-wrap: wrap;
  align-items: space-between;
  align-content: space-between;
  padding: var(--footerLicencesPadding);
  justify-content: var(--footerLicencesJustifyContent);
  max-width: var(--footerLicencesMaxWidth);
  margin: var(--footerLicencesMargin);

  img {
    width: 80px;
    margin-left: 10px;
  }
  div {
    margin: var(--footerLicencesDivMargin);
    display: var(--footerLicencesDivDisplay);
    align-items: var(--footerLicencesDivAlignItems);
    width: var(--footerLicencesDivWidth);
    height: var(--footerLicencesDivHeight);
    border-left: ${isMobile ? "" : "var(--footerLicencesDivBorderDesktop)"};
    justify-content: center;
    text-align: center;
    border-right: ${isMobile ? "" : "var(--footerLicencesDivBorderDesktop)"};
  }
  div:last-child {
    img {
      width: 30px;
    }
    border-right: ${isMobile
      ? ""
      : "var(--footerLicencesDivLastBorderDesktop)"};
  }
  .st0,
  .st4 {
    fill: var(--footerLicencesStFill);
    justify-content: center;
  }
  .cls-1 {
    fill: var(--footerLicencesCls1Fill);
  }

  @media screen and (max-width: 767px) {
    justify-content: var(--footerLicencesJustifyMobile);
    padding: 15px 0;
    div {
      margin: 0;
      width: 33.3%;
      height: 50px;
      padding: 10px;
    }
    img {
      width: 100%;
    }
    svg {
      width: 100%;
    }
  }
`;

export const Copyrightght = styled.div`
  padding: 10px;
  text-align: center;

  p {
    color: var(--footerCopyrightColor, var(--footerTextColor));
    font-size: var(--footerCopyrightFontSize, 1rem);
    padding: 10px;
    :first-child {
      padding-left: 0;
    }
  }

  @media (max-width: 767px) {
    p {
      font-size: 0.8rem;
    }
  }
`;

export const ProviderLogos = styled.img`
  margin: ${({ licences }) => !licences && "10px 12px"};
  width: 120px !important;

  @media (max-width: 767px) {
    width: 80px !important;
  }
  svg {
    height: 30px;
    width: ${!isMobile && "100px"};
  }
`;
export const ProviderThemes = styled.img`
  margin: 10px 12px;
  width: 100%;
  padding: 0 !important;
  border-radius: 0.5rem;

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const FilterByTheme = styled.div`
  margin: auto;
  text-align: center;
  width: 150px !important;
  height: 100px;
  font-size: 1.1rem;
  transform: rotate(-10deg);
  padding-top: 35px;

  p {
    font-weight: 900;
    margin-top: 2rem;
    background: #0554b3;
    background: -webkit-linear-gradient(to right, #0554b3 0%, #cf1f2c 100%);
    background: -moz-linear-gradient(to right, #0554b3 0%, #cf1f2c 100%);
    background: linear-gradient(to right, #0554b3 0%, #cf1f2c 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @media (max-width: 767px) {
    width: 110px !important;
    height: 65px !important;
    padding-top: 20px;
  }
`;

export const PaymentMethodsHeader = styled.h3`
  font-family: var(--footerPaymentHeaderFontFamily, inherit);
  color: var(--newsText);
  font-weight: var(--footerPaymentHeaderFontWeight, 800);
  font-size: 1.33rem;

  @media screen and (max-width: 767px) {
    padding: 10px 50px;
    line-height: 1.6;
  }
`;

export const PaymentProviderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: var(--footerPaymentWrapperMinHeight);

  @media screen and (max-width: 767px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: ${isDesktop && "300px"};

    img {
      width: 80px;
      height: 25px;
    }
  }
`;

export const PaymentProvider = styled.div`
  margin: 20px 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: var(--footerPaymentAlignItems);
  align-content: center;
  justify-content: var(--footerPaymentJustifyContent);
  max-width: var(--footerPaymentMaxWidth);
  min-height: var(--footerPaymentMinHeight);
  border-right: var(--footerPaymentBorderSide);
  border-left: var(--footerPaymentBorderSide);

  .extra-border {
    :first-child {
      border-left: none;
    }
    :last-child {
      border-right: var(--footerPaymentExtraBorderRight);

      @media (max-width: 767px) {
        border-right: none;
      }
      @media (min-width: 768px) and (max-width: 1024px) {
        border-right: none;
      }
    }

    border-left: ${!isMobile
      ? "var(--footerPaymentExtraBorderLeftDesktop)"
      : ""};
  }

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80px;
  }

  @media (max-width: 640px) {
    justify-content: center;
    max-width: var(--footerPaymentMaxWidthMobile);
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    justify-content: var(--footerPaymentJustifyTablet);
    max-width: var(--footerPaymentMaxWidthTablet);
  }
`;

export const PUBFooterImg = styled.div`
  background-image: url(${PUBfooter});
  background-size: ${isMobile ? "contain" : "cover"};
  background-repeat: no-repeat;
  background-position: center;
  width: ${isMobile ? "100%" : "800px"};
  height: ${isMobile ? "180px" : "400px"};
  margin: auto;
`;

export const PUBFooterImgSafari = styled(PUBFooterImg)`
  background-image: url(${PUBfooterSafari});
`;
